/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const invoiceItems = sqliteTable('invoice_items', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  invoice_id: text('invoice_id'),
  service_name: text('service_name'),
  service_id: text('service_id'),
  qty: integer('qty'),
  unit_price: real('unit_price'),
  discount: real('discount'),
  tax_rate: real('tax_rate'),
  remarks: text('remarks'),
  add_to_treatment: integer('add_to_treatment'),
  sort_order: integer('sort_order'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
